import { atom, useAtom } from "jotai";

import { InterestRateData } from "#/types/options";

export const interestRateDataAtom = atom<InterestRateData | null>(null);

export const useInterestRateData = () => {
  const [interestRateData, setInterestRateData] = useAtom(interestRateDataAtom);

  return {
    interestRateData,
    setInterestRateData,
  };
};
